import { createActions, createReducer } from 'reduxsauce'

const { Types, Creators } = createActions({
  ambassadorApplicationStatusRequest: null,
  ambassadorApplicationStatusSuccess: ['data'],
  ambassadorApplicationStatusFailure: ['error'],
  clearAmbassadorStatus: null,

  fetchLeadsRequest:       ['payload'],
  fetchLeadsSuccess:       ['data'],
  fetchLeadsFailure:       ['error'],
  fetchAllVerifiedLeadsRequest:  ['payload'],
  fetchAllVerifiedLeadsSuccess:  ['data'],
  fetchAllVerifiedLeadsFailure:  ['error'],
  searchingLeadsRequest:   ['query', 'filters', 'page', 'size'],
  searchingLeadsSuccess:   ['data'],
  searchingLeadsFailure:   ['error'],
  fetchLeadRequest:        ['id'],
  fetchLeadSuccess:        ['data'],
  fetchLeadFailure:        ['error'],
  createLeadRequest:       ['payload'],
  createLeadSuccess:       ['data'],
  createLeadFailure:       ['error'],
  clearLeadCreation:       null,
  attachLeadVideoRequest:  ['leadId', 'file', 'title'],
  attachLeadVideoProgress: ['progress'],
  attachLeadVideoSuccess:  ['data'],
  attachLeadVideoFailure:  ['error'],
  leadUploadStatusRequest: ['jobId'],
  leadUploadStatusSuccess: ['data'],
  leadUploadStatusFailure: ['error'],
  createLeadEnquiryRequest:  ['payload'],
  createLeadEnquirySuccess:  ['data'],
  createLeadEnquiryFailure:  ['error'],
  clearLeadEnquiry:          null,
  fetchMyEnquiriesRequest:   ['payload'],
  fetchMyEnquiriesSuccess:   ['data'],
  fetchMyEnquiriesFailure:   ['error'],
  createLeadReviewRequest:  ['leadId', 'payload'],
  createLeadReviewSuccess:  ['data'],
  createLeadReviewFailure:  ['error'],
  clearLeadReview:          null,
  fetchLeadReviewsRequest:  ['leadId', 'options'],
  fetchLeadReviewsSuccess:  ['data'],
  fetchLeadReviewsFailure:  ['error'],
})

export const AmbassadorTypes   = Types
export const AmbassadorActions = Creators

const INITIAL_STATE = {
  applicationStatusLoading: false,
  applicationStatus:        null,
  applicationStatusError:   null,

  fetchingLeads:    false,
  leads:            null,
  leadsError:       null,
  fetchingAllVerifiedLeads: false,
  verifiedLeads:          null,
  verifiedLeadsError:     null,
  searchingLeads:   false,
  searchLeadsData:  null,
  searchLeadsError: null,
  fetchingLead:     false,
  lead:             null,
  leadError:        null,
  creatingLead:     false,
  createdLead:      null,
  createLeadError:  null,
  attachingLeadVideo: false,
  leadVideoProgress:   0,
  leadVideoUploadSuccess: null,
  leadVideoUploadError:  null,
  fetchingLeadUploadStatus: false,
  leadUploadStatus:     null,
  leadUploadStatusError: null,
  creatingLeadEnquiry:    false,
  createdLeadEnquiry:     null,
  createLeadEnquiryError: null,
  fetchingMyEnquiries:    false,
  myEnquiries:            null,
  myEnquiriesError:       null,
  creatingLeadReview:     false,
  createdLeadReview:      null,
  createLeadReviewError:  null,
  fetchingLeadReviews:    false,
  leadReviews:            null,
  leadReviewsError:       null,
}

const ambassadorApplicationStatusRequest = (state) => ({
  ...state, applicationStatusLoading: true, applicationStatus: null, applicationStatusError: null,
})

const ambassadorApplicationStatusSuccess = (state, action) => ({
  ...state, applicationStatusLoading: false, applicationStatus: action.data,
})

const ambassadorApplicationStatusFailure = (state, action) => ({
  ...state, applicationStatusLoading: false, applicationStatusError: action.error,
})

const clearAmbassadorStatus = () => ({ ...INITIAL_STATE })

const fetchLeadsRequest = (state) => ({
  ...state, fetchingLeads: true, leadsError: null,
})

const fetchLeadsSuccess = (state, action) => ({
  ...state, fetchingLeads: false, leads: action.data,
})

const fetchLeadsFailure = (state, action) => ({
  ...state, fetchingLeads: false, leadsError: action.error,
})

const fetchAllVerifiedLeadsRequest = (state) => ({
  ...state, fetchingAllVerifiedLeads: true, verifiedLeadsError: null,
})

const fetchAllVerifiedLeadsSuccess = (state, action) => ({
  ...state, fetchingAllVerifiedLeads: false, verifiedLeads: action.data,
})

const fetchAllVerifiedLeadsFailure = (state, action) => ({
  ...state, fetchingAllVerifiedLeads: false, verifiedLeadsError: action.error,
})

const searchingLeadsRequest = (state) => ({
  ...state, searchingLeads: true, searchLeadsError: null,
})

const searchingLeadsSuccess = (state, action) => ({
  ...state, searchingLeads: false, searchLeadsData: action.data,
})

const searchingLeadsFailure = (state, action) => ({
  ...state, searchingLeads: false, searchLeadsError: action.error,
})

const fetchLeadRequest = (state) => ({
  ...state, fetchingLead: true, lead: null, leadError: null,
})

const fetchLeadSuccess = (state, action) => ({
  ...state, fetchingLead: false, lead: action.data,
})

const fetchLeadFailure = (state, action) => ({
  ...state, fetchingLead: false, leadError: action.error,
})

const createLeadRequest = (state) => ({
  ...state, creatingLead: true, createdLead: null, createLeadError: null,
})

const createLeadSuccess = (state, action) => ({
  ...state, creatingLead: false, createdLead: action.data,
})

const createLeadFailure = (state, action) => ({
  ...state, creatingLead: false, createLeadError: action.error,
})

const clearLeadCreation = (state) => ({
  ...state, createdLead: null, createLeadError: null,
})

const attachLeadVideoRequest = (state) => ({
  ...state, attachingLeadVideo: true, leadVideoProgress: 0, leadVideoUploadSuccess: null, leadVideoUploadError: null,
})

const attachLeadVideoProgress = (state, action) => ({
  ...state, leadVideoProgress: action.progress,
})

const attachLeadVideoSuccess = (state, action) => ({
  ...state, attachingLeadVideo: false, leadVideoUploadSuccess: action.data,
})

const attachLeadVideoFailure = (state, action) => ({
  ...state, attachingLeadVideo: false, leadVideoUploadError: action.error,
})

const leadUploadStatusRequest = (state) => ({
  ...state, fetchingLeadUploadStatus: true, leadUploadStatusError: null,
})

const leadUploadStatusSuccess = (state, action) => ({
  ...state, fetchingLeadUploadStatus: false, leadUploadStatus: action.data,
})

const leadUploadStatusFailure = (state, action) => ({
  ...state, fetchingLeadUploadStatus: false, leadUploadStatusError: action.error,
})

const createLeadEnquiryRequest = (state) => ({
  ...state, creatingLeadEnquiry: true, createdLeadEnquiry: null, createLeadEnquiryError: null,
})

const createLeadEnquirySuccess = (state, action) => ({
  ...state, creatingLeadEnquiry: false, createdLeadEnquiry: action.data,
})

const createLeadEnquiryFailure = (state, action) => ({
  ...state, creatingLeadEnquiry: false, createLeadEnquiryError: action.error,
})

const clearLeadEnquiry = (state) => ({
  ...state, createdLeadEnquiry: null, createLeadEnquiryError: null,
})

const fetchMyEnquiriesRequest = (state) => ({
  ...state, fetchingMyEnquiries: true, myEnquiriesError: null,
})

const fetchMyEnquiriesSuccess = (state, action) => ({
  ...state, fetchingMyEnquiries: false, myEnquiries: action.data,
})

const fetchMyEnquiriesFailure = (state, action) => ({
  ...state, fetchingMyEnquiries: false, myEnquiriesError: action.error,
})

const createLeadReviewRequest = (state) => ({
  ...state, creatingLeadReview: true, createdLeadReview: null, createLeadReviewError: null,
})

const createLeadReviewSuccess = (state, action) => ({
  ...state, creatingLeadReview: false, createdLeadReview: action.data,
})

const createLeadReviewFailure = (state, action) => ({
  ...state, creatingLeadReview: false, createLeadReviewError: action.error,
})

const clearLeadReview = (state) => ({
  ...state, createdLeadReview: null, createLeadReviewError: null,
})

const fetchLeadReviewsRequest = (state) => ({
  ...state, fetchingLeadReviews: true, leadReviewsError: null,
})

const fetchLeadReviewsSuccess = (state, action) => ({
  ...state, fetchingLeadReviews: false, leadReviews: action.data,
})

const fetchLeadReviewsFailure = (state, action) => ({
  ...state, fetchingLeadReviews: false, leadReviewsError: action.error,
})

export default createReducer(INITIAL_STATE, {
  [Types.AMBASSADOR_APPLICATION_STATUS_REQUEST]: ambassadorApplicationStatusRequest,
  [Types.AMBASSADOR_APPLICATION_STATUS_SUCCESS]: ambassadorApplicationStatusSuccess,
  [Types.AMBASSADOR_APPLICATION_STATUS_FAILURE]: ambassadorApplicationStatusFailure,
  [Types.CLEAR_AMBASSADOR_STATUS]:              clearAmbassadorStatus,

  [Types.FETCH_LEADS_REQUEST]:   fetchLeadsRequest,
  [Types.FETCH_LEADS_SUCCESS]:   fetchLeadsSuccess,
  [Types.FETCH_LEADS_FAILURE]:   fetchLeadsFailure,
  [Types.FETCH_ALL_VERIFIED_LEADS_REQUEST]: fetchAllVerifiedLeadsRequest,
  [Types.FETCH_ALL_VERIFIED_LEADS_SUCCESS]: fetchAllVerifiedLeadsSuccess,
  [Types.FETCH_ALL_VERIFIED_LEADS_FAILURE]: fetchAllVerifiedLeadsFailure,
  [Types.SEARCHING_LEADS_REQUEST]: searchingLeadsRequest,
  [Types.SEARCHING_LEADS_SUCCESS]: searchingLeadsSuccess,
  [Types.SEARCHING_LEADS_FAILURE]: searchingLeadsFailure,
  [Types.FETCH_LEAD_REQUEST]:    fetchLeadRequest,
  [Types.FETCH_LEAD_SUCCESS]:    fetchLeadSuccess,
  [Types.FETCH_LEAD_FAILURE]:    fetchLeadFailure,
  [Types.CREATE_LEAD_REQUEST]:   createLeadRequest,
  [Types.CREATE_LEAD_SUCCESS]:   createLeadSuccess,
  [Types.CREATE_LEAD_FAILURE]:   createLeadFailure,
  [Types.CLEAR_LEAD_CREATION]:   clearLeadCreation,
  [Types.ATTACH_LEAD_VIDEO_REQUEST]: attachLeadVideoRequest,
  [Types.ATTACH_LEAD_VIDEO_PROGRESS]: attachLeadVideoProgress,
  [Types.ATTACH_LEAD_VIDEO_SUCCESS]: attachLeadVideoSuccess,
  [Types.ATTACH_LEAD_VIDEO_FAILURE]: attachLeadVideoFailure,
  [Types.LEAD_UPLOAD_STATUS_REQUEST]: leadUploadStatusRequest,
  [Types.LEAD_UPLOAD_STATUS_SUCCESS]: leadUploadStatusSuccess,
  [Types.LEAD_UPLOAD_STATUS_FAILURE]: leadUploadStatusFailure,
  [Types.CREATE_LEAD_ENQUIRY_REQUEST]: createLeadEnquiryRequest,
  [Types.CREATE_LEAD_ENQUIRY_SUCCESS]: createLeadEnquirySuccess,
  [Types.CREATE_LEAD_ENQUIRY_FAILURE]: createLeadEnquiryFailure,
  [Types.CLEAR_LEAD_ENQUIRY]:          clearLeadEnquiry,
  [Types.FETCH_MY_ENQUIRIES_REQUEST]: fetchMyEnquiriesRequest,
  [Types.FETCH_MY_ENQUIRIES_SUCCESS]: fetchMyEnquiriesSuccess,
  [Types.FETCH_MY_ENQUIRIES_FAILURE]: fetchMyEnquiriesFailure,
  [Types.CREATE_LEAD_REVIEW_REQUEST]: createLeadReviewRequest,
  [Types.CREATE_LEAD_REVIEW_SUCCESS]: createLeadReviewSuccess,
  [Types.CREATE_LEAD_REVIEW_FAILURE]: createLeadReviewFailure,
  [Types.CLEAR_LEAD_REVIEW]:          clearLeadReview,
  [Types.FETCH_LEAD_REVIEWS_REQUEST]: fetchLeadReviewsRequest,
  [Types.FETCH_LEAD_REVIEWS_SUCCESS]: fetchLeadReviewsSuccess,
  [Types.FETCH_LEAD_REVIEWS_FAILURE]: fetchLeadReviewsFailure,
})